import {
  Api_AccountStatementNew,
  Api_CreateCase,
  APi_CMS_IntegrationVariables,
  Api_Create_Case_Query,
  Api_Create_Case_Query_Multiple,
  Api_Create_Order,
  Api_CrmCaseCreate,
  Api_Customer_Info,
  Api_Dataservice,
  APi_DownloadPolicyAccountStatement,
  Api_DownloadTaxCertificate,
  Api_FetchBondPolicy,
  Api_FetchDashboardDetails,
  Api_FetchFundDetails,
  Api_Fetchlan,
  Api_FetchLiCaseQueryCrm,
  Api_FetchNSDLPANDetails,
  Api_FetchPolBankDetails,
  Api_FetchPolicyAllDetails,
  Api_FetchPolicyDetails,
  Api_FetchPolicyDetailsByMobileNumber,
  Api_FetchPremium_Receipt_WithDate,
  Api_FetchProfile_Details,
  Api_FetchRecentUpdates,
  Api_FetchUserProductStatus,
  APi_FolioSchemeSummary,
  Api_GenerateOtp,
  Api_GenerateSso_Old,
  Api_GetCustomerLobDetails,
  Api_GetCustomerLobDetailsV2,
  Api_LiGetBankName,
  Api_LiGetOtp,
  Api_LiKarzaBankAccount,
  Api_LiNpsZoneDetails,
  Api_LiSaveNpsFeedback,
  Api_LiSetAlertExisting,
  Api_LiUploadDoc,
  Api_LiValidateOtp,
  Api_LiWhatsappOptIn,
  Api_LmsLeadRedirection,
  Api_Order_Status,
  Api_ReportingService,
  Api_ValidateOtp,
  Api_ValidatePan,
  Api_WelcomeKitService,
  Api_WhatsappOpt,
  HomeLoanIdentifier,
  Api_TeraDataUserRegistration,
  Api_UnifiedOfferDetails,
  Api_DelinkFolioList,
  Api_SaveHoldings,
  Api_SaveUiException,
  Api_FetchConsent,
  Api_PolicyInsured,
  Api_RateUs,
  Api_Sfdc_Case_Create,
  Api_SaveConsent,
  Api_Mpin_Exist,
  Api_CreateMpin,
  Api_ValidateMpin,
  Api_Mpin_Forget,
  Api_Register_Biometric,
  Api_SaveUnifiedOfferAndPromotionalCardDetails,
  Api_Delete_Secoundary_Holding,
  Api_Update_User_Profile,
  Api_DownloadECard,
  Api_FoliosSummary,
  Api_DownloadPolicyDocs,
  API_DownloadStatementOfTransaction,
  API_DownloadStatementOfAccount,
  API_DownloadContractNote,
  API_CapitalGainStatementDownload,
  API_FetchPortfolio,
  Api_GenerateLmsLead,
  Api_SaveInsuranceActivity,
  Api_FetchUserTransactionStatus,
  Api_DownloadMotorPolicyDocument,
  Api_FetchPocketInsurancePolicyDocument,
  Api_FetchTravelInsurancePolicyDocument,
  Api_SaveCampaignDetails,
  Api_Save_Service_Request,
  Api_LiProfileDetails,
  Api_SaveCrossSellContent,
  Api_GenAppSaveNpsFeedback,
  Api_FetchPastPaymentDetails,
  Api_SendEmail,
  Api_SendWhatsApp,
  Api_DownloadPremium_Receipt,
  Api_DownloadCapitalStatementNew,
  Api_LastTransactionBroker,
  Api_ExitLoad,
  API_FetchHoldingsFromClientId,
  Api_FetchCountDetails,
  Api_FetchLiReKycStatus,
  Api_Li_Save_Service_Request,
  Api_FetchHLEmailCount,
  Api_FetchHLAdvanceEMI_Payment_Detail,
  Api_FetchVerifiedPanDetails,
  Api_SaveVerifiedPanDetails,
  Api_FetchHLRoiHistory,
  Api_FetchCaseStatus,
  Api_Fetch_L2_Banner,
  Api_Fetch_Center_Banner,
  Api_HomeLoan_Validate_Otp,
  Api_HomeLoan_Generate_Otp,
  Api_Li_FetchMobileFromPolicyId,
  Api_Fetch_PDD_Information,
} from "../utils/ApiEndpoints";

export const encryptedResponseAPIList = [
  // General / onboarding
  Api_GetCustomerLobDetails,
  Api_GetCustomerLobDetailsV2,
  Api_FetchProfile_Details,
  Api_GenerateOtp,
  Api_ValidateOtp,
  Api_TeraDataUserRegistration,
  Api_UnifiedOfferDetails,
  Api_GenerateSso_Old,
  Api_FetchConsent,
  Api_RateUs,
  Api_SaveConsent,
  Api_FetchCaseStatus,

  // CMS
  APi_CMS_IntegrationVariables,

  // Life Insurance
  Api_FetchPolicyDetails,
  Api_FetchDashboardDetails,
  Api_LiKarzaBankAccount,
  Api_LiUploadDoc,
  Api_FetchNSDLPANDetails,
  Api_DownloadTaxCertificate,
  Api_FetchPremium_Receipt_WithDate,
  Api_FetchPolicyAllDetails,
  Api_LiNpsZoneDetails,
  Api_FetchPolBankDetails,
  Api_FetchFundDetails,
  Api_LiProfileDetails,
  Api_FetchCountDetails,
  Api_FetchLiReKycStatus,
  Api_Li_FetchMobileFromPolicyId,

  // Mutual Fund and Stocks
  Api_ValidatePan,
  APi_FolioSchemeSummary,
  Api_AccountStatementNew,
  Api_DelinkFolioList,
  API_FetchPortfolio,
  Api_ExitLoad,
  API_FetchHoldingsFromClientId,

  // Health Insurance
  Api_FetchPolicyDetailsByMobileNumber,
  Api_PolicyInsured,
  Api_DownloadPolicyDocs,

  // Home Loan
  HomeLoanIdentifier,
  Api_Customer_Info,
  Api_FetchHLEmailCount,
  Api_FetchHLAdvanceEMI_Payment_Detail,
  Api_FetchHLRoiHistory,
  Api_HomeLoan_Validate_Otp,
  Api_HomeLoan_Generate_Otp,
  Api_Fetch_PDD_Information,

  // ABCD Holdings
  Api_FetchUserTransactionStatus,
  Api_DownloadMotorPolicyDocument,

  // ABFL
  Api_FetchVerifiedPanDetails,
];

export const encryptedRequestAPIList = [
  // General / onboarding
  Api_GetCustomerLobDetails,
  Api_GetCustomerLobDetailsV2,
  Api_GenerateOtp,
  Api_ValidateOtp,
  Api_TeraDataUserRegistration,
  Api_UnifiedOfferDetails,
  Api_GenerateSso_Old,
  Api_SaveHoldings,
  Api_SaveUiException,
  Api_FetchConsent,
  Api_RateUs,
  Api_SaveConsent,
  Api_Mpin_Exist,
  Api_CreateMpin,
  Api_ValidateMpin,
  Api_Mpin_Forget,
  Api_Register_Biometric,
  Api_SaveUnifiedOfferAndPromotionalCardDetails,
  Api_Delete_Secoundary_Holding,
  Api_Update_User_Profile,
  Api_SaveCampaignDetails,
  Api_SaveCrossSellContent,
  Api_GenAppSaveNpsFeedback,
  Api_FetchCaseStatus,

  // Life Insurance
  Api_FetchPolicyAllDetails,
  Api_FetchDashboardDetails,
  Api_DownloadTaxCertificate,
  Api_FetchPolicyDetails,
  Api_FetchRecentUpdates,
  Api_LiGetOtp,
  Api_LiValidateOtp,
  Api_LiGetBankName,
  Api_CrmCaseCreate,
  Api_WhatsappOpt,
  Api_LiWhatsappOptIn,
  APi_DownloadPolicyAccountStatement,
  Api_LiKarzaBankAccount,
  Api_FetchBondPolicy,
  Api_FetchPolBankDetails,
  Api_FetchFundDetails,
  Api_LiNpsZoneDetails,
  Api_LiSaveNpsFeedback,
  Api_LiSetAlertExisting,
  Api_LiUploadDoc,
  Api_FetchNSDLPANDetails,
  Api_FetchLiCaseQueryCrm,
  Api_FetchPremium_Receipt_WithDate,
  Api_LiProfileDetails,
  Api_FetchPastPaymentDetails,
  Api_SendWhatsApp,
  Api_SendEmail,
  Api_DownloadPremium_Receipt,
  Api_FetchCountDetails,
  Api_FetchLiReKycStatus,
  Api_Li_Save_Service_Request,
  Api_Li_FetchMobileFromPolicyId,

  // Mutual Fund and Stocks
  Api_ExitLoad,
  Api_LastTransactionBroker,
  Api_FoliosSummary,
  APi_FolioSchemeSummary,
  Api_ValidatePan,
  API_FetchPortfolio,
  API_DownloadStatementOfTransaction,
  API_DownloadContractNote,
  API_DownloadStatementOfAccount,
  API_CapitalGainStatementDownload,
  Api_DownloadCapitalStatementNew,
  Api_AccountStatementNew,
  API_FetchHoldingsFromClientId,

  // Home Loan
  HomeLoanIdentifier,
  Api_Dataservice,
  Api_Fetchlan,
  Api_CreateCase,
  Api_ReportingService,
  Api_WelcomeKitService,
  Api_Create_Order,
  Api_Order_Status,
  Api_Create_Case_Query,
  Api_Create_Case_Query_Multiple,
  Api_Customer_Info,
  Api_FetchHLEmailCount,
  Api_FetchHLAdvanceEMI_Payment_Detail,
  Api_FetchHLRoiHistory,
  Api_HomeLoan_Validate_Otp,
  Api_HomeLoan_Generate_Otp,
  Api_Fetch_PDD_Information,

  // ABCD Holdings
  Api_LmsLeadRedirection,
  Api_FetchUserProductStatus,
  Api_GenerateLmsLead,
  Api_SaveInsuranceActivity,
  Api_FetchUserTransactionStatus,
  Api_DownloadMotorPolicyDocument,
  Api_FetchPocketInsurancePolicyDocument,
  Api_FetchTravelInsurancePolicyDocument,
  Api_DelinkFolioList,

  // Health Insurance
  Api_PolicyInsured,
  Api_Sfdc_Case_Create,
  Api_FetchPolicyDetailsByMobileNumber,
  Api_DownloadECard,
  Api_DownloadPolicyDocs,
  Api_Save_Service_Request,

  // CMS
  Api_Fetch_L2_Banner,
  Api_Fetch_Center_Banner,

  // ABFL
  Api_FetchVerifiedPanDetails,
  Api_SaveVerifiedPanDetails,
];

export const apiListForAccountTakeOver = [
  Api_GenerateOtp,
  Api_ValidateOtp,
  Api_Update_User_Profile,
  Api_FetchPolicyDetails,
  Api_DownloadTaxCertificate,
  Api_DownloadCapitalStatementNew,
  Api_AccountStatementNew,
  Api_Li_FetchMobileFromPolicyId,
];

export const apiListToAvoidResTokenValidation = [
  Api_FetchPolicyDetails,
  Api_DownloadTaxCertificate,
  Api_DownloadCapitalStatementNew,
  Api_AccountStatementNew,
  Api_Li_FetchMobileFromPolicyId,
];
